export enum PaymentStrategy {
    asaas_boleto = 'asaas_boleto',
    asaas_credit_card = 'asaas_credit_card',
}
